module.exports = __webpack_public_path__ + "static/img/g732.99fdbad3.png";